import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'
import { getBorderRadius, getShadow } from '../../../../utils/styleUtils'

export const GridWrapper = styled.div`
  background-color: transparent;
  width: 100%;
`

export const ItemImageWrapper = styled.div`
  margin-bottom: 10px;
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: ${size.tablet}) {
    justify-content: space-around;
  }
`

export const GridItemWrapper = styled.a`
  width: 381px;
  margin-right: 1.25%;
  margin-bottom: 15px;
  max-width: 48%;

  @media (max-width: ${size.laptop}) {
    width: 348px;
  }

  @media (max-width: ${size.tablet}) {
    width: 100%;
    max-width: 348px;
    margin-left: 0;
    margin-right: 0px;
  }
`

export const GridItemDetailsWrapper = styled.div`
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, '2xl')};
  height: 100%;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  overflow: hidden;
  box-shadow: ${props => getShadow(props, 'sm')};
  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    cursor: pointer;
    box-shadow: ${props => getShadow(props, 'lg')};
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
    border: 1px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  }
`

export const ItemImage = styled.div`
  position: relative;
  height: 150px;
  background-image: url(${({ backgroundImage }) =>
      `"${encodeURI(backgroundImage)}"`}),
    url(${({ backgroundImage }) => `"${backgroundImage}"`});
  background-size: cover;
  background-position: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;

  @media (min-width: ${size.laptop}) {
    height: 175px;
  }
`

export const TripDetailsWrapper = styled.div`
  margin-right: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  justify-content: flex-start;
  position: relative;
`

export const TripSecondaryDetailsWrapper = styled.div`
  margin-right: 5px;
  margin-bottom: 0px;
  padding: 10px;
  padding-top: 0px;
  display: flex;
  flex-direction: row;
  position: relative;
  text-align: left;
  flex-direction: column;
`
export const TripSecondaryDetailsItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const RelevancyInfo = styled.span`
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 5px;
  line-height: 15px;
  padding: 2px 5px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
`

export const TripSecondaryDetails = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 15px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0px;
  margin: 0;
  line-height: 18px;
  margin-right: 3px;
`

export const TripInfoWrapper = styled.div`
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 10px 15px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: left;
`
export const TripInfo = styled.div`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0px;
  padding-top: 5px;
  margin: 0;
  line-height: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const TripInfoItem = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0px;
  margin: 0;
  line-height: 15px;
  text-transform: capitalize;
`

export const TripInfoAvailibility = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  padding: 0px;
  margin: 0;
  line-height: 15px;
  padding: 2px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
`

export const TripInfoTitle = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0px;
  margin: 0;
  padding-bottom: 5px;
  line-height: 14px;
  border-bottom: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  width: fit-content;
`

export const TitleWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: transparent;
  text-align: left;
  padding-bottom: 5px;
`

export const Title = styled.h3`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_TITLE_TEXT_TRANSFORM};
`

export const LabelBottomWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: transparent;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 5px;
`

export const LabelBottom = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: capitalize;
`

export const RatingImageWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: transparent;
  text-align: left;
`

export const RatingImage = styled.img`
  height: 22px;
  width: auto;
`

export const Location = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 15px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  right: 0px;
  line-height: 24px;
  font-weight: 700;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_LOCATION_TEXT_TRANSFORM};
`

export const Keywords = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM};
`

export const Description = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 14px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
`

export const GridTitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 20px;
  line-height: 30px;
  font-weight: 800;
  margin: 20px 0 15px;
  text-transform: uppercase;
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};

  @media (max-width: ${size.tablet}) {
    font-size: 16px;
    line-height: 20px;
    margin: 20px 0 15px;
  }
`

export const GridSubtitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 15px 0px 25px 0px !important;
  padding: ${props => {
    return props?.isChatMode ? '0px 15px 0px 15px' : '0px'
  }};
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};
  text-align: center;
  font-style: italic;

  @media (max-width: ${size.tablet}) {
    font-size: 14px;
    line-height: 20px;
    margin: 15px 0px 25px 0px !important;
  }
`

export const TripTypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  text-decoration: none;
`

export const TripTypeOnImage = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  background: none;

  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  position: absolute;
  left: -5px;
  top: 10px;
  text-transform: uppercase;
  text-align: left;
  max-width: 95%;

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const TripTypeOnCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-radius: 0px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-top-left-radius: ${props => getBorderRadius(props, '2xl')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 5px 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  position: absolute;
  right: -5px;
  bottom: 0px;
  text-transform: uppercase;

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const ShowMoreCta = styled.button`
  display: flex;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  margin: 15px auto;
  align-self: stretch;

  @media (max-width: ${size.laptop}) {
    font-size: 14px;
  }

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    border-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`
